import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserGroup, faCircleQuestion, faUserPlus } from '@fortawesome/free-solid-svg-icons';

import { ReactComponent as CrystalBallIcon } from 'assets/icons/CrystalBallIcon.svg';
import LiveEvents from 'assets/art/LiveEvents.webp';


const menuItems = [
  {
    menuicon: <CrystalBallIcon />,
    name: 'Prediction',
    link: '/prediction',
    cssClasses: '',
    primary: true,
    dropdown: [],
  },
  {
    menuicon: null,
    name: 'BTC on BSC',
    link: '/prediction/bsc/btc',
    dropdown: [],
  },
  {
    menuicon: null,
    name: 'BNB on BSC',
    link: '/prediction/bsc/bnb',
    dropdown: [],
  },
  /*
  {
    menuicon: null,
    name: 'DOGE on DogeChain',
    link: '/prediction/dc/doge',
    dropdown: [],
  },
  {
    menuicon: null,
    name: 'BTC on DogeChain',
    link: '/prediction/dc/btc',
    dropdown: [],
  },
  */
  {
    menuicon: <img src={LiveEvents} alt='icon'></img>,
    name: 'LiveEvents',
    link: '/live-events',
    cssClasses: '',
    primary: true,
    dropdown: [],
  },
  {
    menuicon: <FontAwesomeIcon icon={faUserGroup} />,
    name: "Socials",
    link: '/social#top',
    cssClasses: 'Socials',
    primary: true,
    dropdown: [],
  },
  {
    menuicon: <FontAwesomeIcon icon={faCircleQuestion} />,
    name: "FAQ",
    link: '/faq#top',
    cssClasses: 'Socials',
    primary: true,
    dropdown: [],
  },
  {
    menuicon: <FontAwesomeIcon icon={faUserPlus} />,
    name: 'Referrals, BSC data',
    link: '/referrals/bsc',
    primary: true,
    dropdown: [],
  },
  /*
  {
    menuicon: <FontAwesomeIcon icon={faUserPlus} />,
    name: 'Referrals, DogeChain data',
    link: '/referrals/dogechain',
    primary: true,
    dropdown: [],
  },
  */
  /*
  {
    menuicon: <FontAwesomeIcon icon={faRightLeft} className="w-6" />,
    name: "Exchange",
    link: '/exchange#top',
    primary: false,
    dropdown: [],
  },
  */
];


export default menuItems;
